<template>
  <div class="min-w-56 py-1">
    <slot />
  </div>
</template>
